import React from 'react';
import { useTranslation } from 'react-i18next';
import science_cares from '../assets/images/hearts_science_cares.png';
import videoSource from '../assets/videos/hearts_science_cares.mp4';

const VideoSection = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-0 md:mx-4 mt-32 mb-32 relative">
      <div className="mx-auto">
        <div className="relative bg-gray-900 overflow-hidden w-full">
          {/* Video Container with max-height */}
          <div className="relative w-full">
            <video
              className="h-[90vh] md:h-auto md:w-full max-h-[90vh] object-cover"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={videoSource} type="video/mp4" />
              {t('video.notSupported')}
            </video>

            {/* Text Overlay with larger text on bigger screens */}
            <div className="absolute inset-0 bg-black/50 flex">
              <div className="w-full lg:w-2/3 xl:w-1/2 pt-8 px-8 flex flex-col text-white">
                <h2 className="text-xl md:text-3xl lg:text-4xl xl:text-5xl font-bold xl:mb-12 mb-2 text-[#49ABDB]">
                  {t('video.title')}
                </h2>
                
                <p className="text-xs md:text-base lg:text-lg xl:text-xl xl:mb-8 mb-2">
                  {t('video.paragraph1')}
                </p>
                
                <p className="text-xs md:text-base lg:text-lg xl:text-xl italic xl:mb-8 mb-2 text-[#49ABDB]">
                  {t('video.paragraph2')}
                </p>
                
                <p className="text-xs md:text-base lg:text-lg xl:text-xl italic font-bold text-[#49ABDB]">
                  {t('video.paragraph3')}
                </p>
              </div>
            </div>

            {/* Bottom Image - Larger on bigger screens */}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2">
              <img
                src={science_cares}
                alt={t('video.imageAlt')}
                className="w-24 h-24 md:w-32 md:h-32 lg:w-64 lg:h-64 xl:w-96 xl:h-96 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection;